module.exports = __webpack_public_path__ + "fonts/montserrat-v30-latin-regular.4bc3bc9.woff2";